import { Button } from "@mui/material";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useContext, useState } from "react";
import SessionContext from "../contexts/session";
import { useTranslation, Trans } from "react-i18next";

import {
  Avatar,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  Stack,
  Typography,
} from "@mui/material";

import { FormatN2W, truncateAddress } from "../utils";
import { Link } from "react-router-dom";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useDisconnect } from "wagmi";

export default function ButtonConnect() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <ConnectButton.Custom>
      {({ account, openConnectModal }) => (
        <>
          {account ? (
            <div>
              <UserMenu
                open={Boolean(anchorEl)}
                handleClose={() => setAnchorEl(null)}
                anchorEl={anchorEl}
              />
              <IconButton onClick={handleClick}>
                <Avatar></Avatar>
              </IconButton>
            </div>
          ) : (
            <>
              <Button
                variant="contained"
                color="info"
                onClick={openConnectModal}
                sx={{ display: { xs: "none", sm: "block" } }}
              >
                <Trans t={t}>Connect</Trans>
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={openConnectModal}
                sx={{ display: { xs: "block", sm: "none" } }}
                size="small"
              >
                <Trans t={t}>Connect</Trans>
              </Button>
            </>
          )}
        </>
      )}
    </ConnectButton.Custom>
  );
}

function UserMenu({ open, handleClose, anchorEl, handleClickDisconnect }) {
  const { t } = useTranslation();
  const { account, user } = useContext(SessionContext);
  const { disconnect } = useDisconnect();
  return (
    <Popover
      open={open}
      onClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
    >
      <Stack sx={{ minWidth: "250px" }}>
        <Stack
          direction="row"
          spacing={2}
          sx={{ p: 2, alignItems: "flex-start" }}
        >
          <Avatar />
          <Stack spacing={1}>
            <Typography color="secondary" fontSize="small">
              <Trans t={t}>WALLET</Trans>
            </Typography>
            {user?.verified && (
              <Typography>
                {user.username}
                <VerifiedIcon color="info" sx={{ verticalAlign: "middle" }} />
              </Typography>
            )}
            <Typography>{truncateAddress(account)}</Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack spacing={1} sx={{ p: 2 }}>
          <Typography color="secondary" fontSize="small">
            <Trans t={t}>N2W BALANCE</Trans>
          </Typography>
          <FormatN2W amount={user?.balance || 0} />
        </Stack>
        <Divider />
        <List disablePadding sx={{ py: 2 }}>
          <ListItem onClick={handleClose} disableGutters disablePadding>
            <ListItemButton component={Link} to={`/user/${account}`}>
              <ListItemText>
                <Trans t={t}>Profile</Trans>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem onClick={handleClose} disableGutters disablePadding>
            <ListItemButton onClick={disconnect}>
              <ListItemText>
                <Trans t={t}>Disconnect</Trans>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </Stack>
    </Popover>
  );
}
